module.exports = __webpack_public_path__ + "img/camera-uni.e987fac0.png";